import React from "react";
import { assignToListIconRed, InfluencerRating } from "../../Components";
import { storageHandler } from "../../Helpers";
import { utils } from "../../Helpers";
import { useNavigate } from "react-router-dom";

export default function ShowInfluencerGrid({
  setUpdateProfilePage,
  updateProfilePage,
  setUserTypeRegOrNon,
  removeInfFromList,
  setSelectedInfluencer,
  item,
  toastList,
  addToast,
  listId,
  setCountOfInf,
  setTabModal,
}) {
  console.log("item", item);
  const navigate = useNavigate();
  const removeFromList = async (event, item) => {
    event.stopPropagation();
    setTabModal("confirmDelete");
    setSelectedInfluencer(item);
  };
  const showInfProfile = (event, item) => {
    event.stopPropagation();
    storageHandler.setUserTypeForProfileItem(JSON.stringify(item.type));
    setUpdateProfilePage(!updateProfilePage);
    navigate("/brand/influencerProfile/" + item.id);
  };

  const userDisplayFormat = (count) => {
    if (count >= 1000000000)
      return (count / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";

    if (count >= 1000000)
      return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";

    if (count >= 1000)
      return (count / 1000).toFixed(1).replace(/\.0$/, "") + "K";

    return count;
  };

  const getStringOfBio = (influencer) => {
    return influencer.bio
      ? influencer.bio !== ""
        ? utils.testJSON(influencer.bio)
          ? utils.draftJsFormatingForDetailsBio({
              data: influencer.bio,
              view: "lessview",
            })
          : influencer.bio.substring(0, 25)
        : ""
      : "";
  };
  return (
    <>
      <div className="cardMain " onClick={(e) => showInfProfile(e, item)} style={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)', border: 'none', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className="top-icons">
          <div className="social-icons flex gap-1 border border-gray-50 bg-gray-100 rounded-full px-3 py-0.5">
            {item.social_accounts?.map((account, idx) => (
              <div
                key={idx}
                style={{
                  marginBottom:
                    idx < item.social_accounts.length - 1 ? "4px" : "0",
                }}
              >
                {account.platform === "IG" && (
                  <img
                    src="images/instagram.svg"
                    width="28"
                    title="instagram"
                    alt="Instagram"
                  />
                )}
                {account.platform === "FB" && (
                  <img
                    src="images/facebook.svg"
                    width="28"
                    title="facebook"
                    alt="Facebook"
                  />
                )}
                {account.platform === "YT" && (
                  <img
                    src="images/youtube.svg"
                    width="28"
                    title="youtube"
                    alt="YouTube"
                  />
                )}
                {account.platform === "TT" && (
                  <img
                    src="images/tiktok-logo.svg"
                    width="28"
                    title="tiktok"
                    alt="TikTok"
                  />
                )}
              </div>
            )) || "-"}
            <span className="text-start text-gray-500 mt-1">
              {userDisplayFormat(
                item.social_accounts?.[item.social_accounts.length - 1]
                  ?.followers || ""
              )}
            </span>
          </div>
          <div className="flex gap-3">
            {item.list_id !== "" && (
              <div class="like-icon" onClick={(e) => removeFromList(e, item)}>
                {assignToListIconRed}
              </div>
            )}
          </div>
        </div>
        <div
          className="image-wrapper"
          style={{
            backgroundImage:
              item.profile_img_url === ""
                ? `url( ${process.env.PUBLIC_URL}/images/placeholder/avatar.png)`
                : `url(${item.profile_img_url})`,
          }}
        ></div>
        <div className="rating">
          <div className="star-container " data-rating="0">
            <InfluencerRating infrating={item.rating}></InfluencerRating>
          </div>
        </div>
        <div className="username">
          {item.display_name ? item.display_name : ""}
        </div>
        {item.bio && item.bio !== "" && (
          <div className="tags">
            <p className="tagstext">
              {item.bio
                ? getStringOfBio(item) !== ""
                  ? getStringOfBio(item)
                  : ""
                : ""}
            </p>
          </div>
        )}
      </div>
    </>
  );
}
